var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('typography-default'), _c('typography-display'), _c('typography-blockquotes'), _c('typography-list'), _c('typography-description')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }